import React, {useEffect, useState} from 'react';
import _ from 'lodash'
import { useSelector, useDispatch } from 'react-redux';
import "./index.css"

import { Sidebar } from 'primereact/sidebar';

import Description from '../../common/Description';
import ButtonGroup from '../../common/ButtonGroup';

// Inputs
import { Table, Button } from '../../helpers';
import Search from './Components/Search';

// Common
import CopyToClipboard from '../../common/CopyToClipboard';


// utils
import { getDateString, getProductName, getProductSpecification, getCompanyShortName, numberConversion, round, getDateTimeString, isMobile, getFullName } from '../../utils';


// redux
import { fetchStockReport, updateSearchParams, setIsSearchVisible } from '../../services/redux/reducers/stock/stockReport';
import { fetchStockMoveTypes, fetchCompanyWarehouses, fetchMaterialBrands, fetchStatus } from '../../services/redux/reducers/commonThunk';
import { raiseToast } from '../../services/redux/reducers/toast/toast';

import { getPMCompanyConfig } from '../../setup/pmCompanyConfig';
import { useNavigate } from 'react-router-dom';


const StockReport = () => {

    const dispatch = useDispatch()

    const isPageLoading = useSelector(state => state.stockReport.loading)
    const stockReportData = useSelector(state => state.stockReport.stockReportData)
    const paginationParams = useSelector(state => state.stockReport.paginationParams)
    const searchParams = useSelector(state => state.stockReport.searchParams)
    const stockMoveTypes = useSelector(state => state.common.stockMoveTypes)
    const companyWarehouses = useSelector(state => state.common.companyWarehouses)
    const materialBrands = useSelector((state) => state.common.materialBrands)
    const statusList = useSelector((state) => state.common.status)
    const searchOptions = useSelector((state) => state.stockReport.searchOptions)
    const isSearchVisible = useSelector(state => state.stockReport.isSearchVisible)
    const isSearchActive = useSelector(state => state.stockReport.isSearchActive)

    const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const navigate = useNavigate()

    const isMobileDevice = isMobile()

    useEffect(()=>{
        dispatch(fetchStockMoveTypes())
        dispatch(fetchCompanyWarehouses())
        dispatch(fetchMaterialBrands())
        dispatch(fetchStatus())
    },[])

    useEffect(() => {
        if (searchParams?.dataType === "allStockMoves") {
            let toDate = new Date()
            toDate.setHours(23, 59, 0, 0)
            toDate = toDate.toISOString()

            let fromDate = new Date()
            fromDate.setDate(fromDate.getDate() - 30)
            fromDate.setHours(0, 0, 0, 0)
            fromDate = fromDate.toISOString()

            const updatedSearchParams = {
                ...searchParams,
                fromDate: fromDate,
                toDate: toDate,
                dateType: "moveDate"
            }

            dispatch(updateSearchParams(updatedSearchParams))
        }
    }, [searchParams.dataType])

    useEffect(() => {
        handleTableColumn(searchParams)
    }, [stockReportData])


    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }

    const handlePageChange = async (e) => {
        let getCompanyParams = { 
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }
        if (getCompanyParams.searchBy !== "all") {
            getCompanyParams[getCompanyParams.searchBy] = getCompanyParams.searchText.trim()
        }
        dispatch(fetchStockReport(getCompanyParams))
    }

    const handleTableColumn = (searchParams) => {
        const { dataType } = searchParams

        switch(dataType) {
            case "allStockMoves" :
                setTableColumns(tableStockMoveColumns)
                break
            case "stockDoc" :
                setTableColumns(tableStockDocColumns)
                break
            case "stockWarehouse" :
                setTableColumns(tableStockWarehouseColumns)
                break
            case "stockMovement" :
                setTableColumns(tableMovementReportColumn)
                break
            case "stockVariance":
                setTableColumns(tableVarianceReportColumns)
                break
            case "buyerPOStock":
                setTableColumns(tablebuyerPOStockReportColumns)
                break
            case "discardedStock":
                setTableColumns(tableStockScrapReportColumns)
                break
            case "stockAging":
                setTableColumns(tableStockAgingReportColumns)
                break
            case "rejectedStock":
                setTableColumns(tableRejectedStockReportColumns)
                break
            case "stockConsumption":
                setTableColumns(tableStockConsumptionReportColumns)
                break
        }
    }

    const getProductBody = (row) => {
        let relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === row?.materialMaster?.brandId)
        let productName = getProductName(relatedBrand?.brandName,row?.materialMaster?.productName, row?.materialMaster?.variantName)
        return (
            <div className='text-left'>{productName}</div>
        )
    }

    const getProductSpecification = (row) => <Description text={row.productSpecification} maxLength={100}  width="300px" />

    const getDocNoandMoveTypeBody = (row) => {
        const relatedStockMoveTypes = stockMoveTypes.find((each) => each.stockMoveTypeId === row?.stockMoveTypeId)
        return(
            <div className="text-center">
                <div className='flex flex-row justify-content-center'>
                    <p className='doc-no' style={{ cursor: "pointer" }}>{row?.docNo}</p>
                    <CopyToClipboard text={row?.docNo} />
                </div>
                <div className='stock-move-name'>
                    { `${relatedStockMoveTypes?.stockMoveName ? relatedStockMoveTypes?.stockMoveName : '-'}`}
                </div>
            </div>
        )
    }

    const getBuyerNameAndBuyerPOIdBody = (row) => {
        return (
            <>
                <div className="">
                    <p className='m-0'>{row.buyerCompanyName ? getCompanyShortName(row.buyerCompanyName) : "-"}</p>
                </div>
            </>
        )
    }

    const getSellerNameAndSellerPOIdBody = (row) => {
        return (
            <>
                <div className="">
                    <p className='m-0'>{row.sellerCompanyName ? getCompanyShortName(row.sellerCompanyName) : '-'}</p>
                </div>
            </>
        )
    }

    const getMoveDateAndCreatedBy = (row) => {
        let dateString = getDateString(row?.createdAt)
        return (
            <div className="text-center">
                <div className={`custom-tool-tip-${dateString}`}>{dateString}</div>
                <div className="user-name">{getFullName(row.firstName, row.lastName)}</div>
            </div>
        )
    }

    const getBuyerDocNoBody = (row) => {
        return (
            <div className="text-center">
                <div className='flex flex-row justify-content-center'>
                    {
                        row.buyerPODocNo ?
                            <>
                                <p className='doc-no' style={{ cursor: "pointer" }} onClick={() => window.open(`/docs/${row.buyerPODocNo}`, '_blank')}>{row.buyerPODocNo}</p>
                                <CopyToClipboard text={row.buyerPODocNo} />
                            </>
                            : <>-</>
                    }
                </div>
            </div>
        )
    }

    const getSellerDocNoBody = (row) => {
        return (
            <div className="text-center">
                <div className='flex flex-row justify-content-center'>
                    {
                        row.sellerPODocNo ?
                            <>
                                <p className='doc-no' style={{ cursor: "pointer" }} onClick={() => window.open(`/docs/${row.sellerPODocNo}`, '_blank')}>{row.sellerPODocNo}</p>
                                <CopyToClipboard text={row.sellerPODocNo} />
                            </>
                            : <>-</>
                    }
                </div>
            </div>
        )
    }

    const getWareHouseNameBody = (row) => {
        const relatedCompanyWarehouse = companyWarehouses.find((each) => each.warehouseId === row?.warehouseId)
        if(relatedCompanyWarehouse?.warehouseName){
            return relatedCompanyWarehouse.warehouseName
        }else{
            return '-'
        }
    }

    const getProductDetailsBody = (row) => {
        let relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === row.brandId)
        let productName = getProductName(relatedBrand?.brandName, row.productName, row.variantName)
        let productSpecification = getProductSpecification(row.productSpecification)
        return (
            <div>{productName} | {productSpecification}</div>
        )
    }

    const getRemarks = (row) => row.remarks ? <Description text={row.remarks} maxLength={100} /> : <p className="text-center">-</p>
    
    const getDocNoBody = (row) => {
        if(row?.docNo){
            return(
                <div className="text-center">
                    <div className='flex flex-row justify-content-center'>
                        <p className='doc-no' style={{ cursor: "pointer" }}>{row?.docNo}</p>
                        <CopyToClipboard text={row?.docNo} />
                    </div>
                </div>
            )
        }else{
            <div> - </div>
        }
    }

    const getStatusBody = (row) => {
        let relatedStatus = statusList.find(eachStatus => eachStatus.statusId === row.statusId)

        return (
            <div>{relatedStatus?.status}</div>
        )
    }

    const getPrice = (row) => {
        if(row?.price !== null){
            return numberConversion(row.price, numberLocale)
        }
        return ""
    }

    const getLastMoveDateAndCreatedBy = (row) => {
        let dateString = getDateString(row?.updatedAt)
        return (
            <div className="text-center">
                <div className={`custom-tool-tip-${dateString}`}>{dateString}</div>
            </div>
        )
    }

    const getRejectedReasonText = (row) => {
        // let rejectedReasonText = row.rejectionReason
        // const reasonInParts = rejectedReasonText.split(/(Reason for Rejection:|Corrective Action:|Preventive Action:)/);

        // return (
        //     <div className='text-left'>
        //         {reasonInParts.map((part, index) => {
        //             if (part.match(/Reason for Rejection:|Corrective Action:|Preventive Action:/)) {
        //                 return (
        //                     <div key={index}>
        //                         <span style={{ fontWeight: '600' }}>{part}</span>
        //                     </div>
        //                 );
        //             }
        //             return <span key={index}>{part}</span>;
        //         })}
        //     </div>
        // )
        let rejectedReasonText = row.rejectionReason;
        const reasonInParts = rejectedReasonText.split(/(Reason for Rejection:|Corrective Action:|Preventive Action:)/);
    
        const updatedReasonsText = reasonInParts.map((part, index) =>
            part.match(/Reason for Rejection:|Corrective Action:|Preventive Action:/) ? (
                <strong key={index}>{part}</strong> 
            ) : (
                <span key={index}>{part}</span>
            )
        )

        return (
            <Description text={updatedReasonsText} maxLength={200} />
        )
    }

    const getVarianceValue = (row) => {
        return(
            <>
                {row.variance ? round(row.variance) : ''}
            </>
        )
    }

    const getPosAdjustedQty = (row) => {
        return(
            <>
                {row['+ve AdjustedQty'] ? row['+ve AdjustedQty'] : '-'}
            </>
        )
    }

    const getNegAdjustedQty = (row) => {
        return(
            <>
                {row['-ve AdjustedQty'] ? row['-ve AdjustedQty'] : '-'}
            </>
        )
    }

    const getSellerPODate = (row) => {
        return(
            <>
                {getDateTimeString(row.sellerPODate)}
            </>
        )
    }

    const getOpeningAmount = (row) => {
        return numberConversion(round(parseFloat(row.openingAmount, 2)), numberLocale)
    }

    const getReceivedAmount = (row) => {
        return numberConversion(round(parseFloat(row.receivedAmount, 2)), numberLocale)
    }

    const getDispatchedAmount = (row) => {
        return numberConversion(round(parseFloat(row.dispatchedAmount, 2)), numberLocale)
    }

    const getClosingAmount = (row) => {
        return numberConversion(round(parseFloat(row.closingAmount, 2)), numberLocale)
    }

    const getStockValue = (row) => {
        const stockValue = row["StockValue"] ? String(row["StockValue"]) : ''
        return numberConversion(round(parseFloat(stockValue, 2)), numberLocale)
    }

    const getSellerInvoiceNo = (row) => {

        const sellerInvs = _.compact(row.sellerInvoiceNo)
        if(!sellerInvs.length){
            return ''
        }

        return sellerInvs.join(', ')
    }

    const getGRNDates = (row) => {
        const date = new Date(row.GRNDate)

        return getDateString(date)
    }

    const getAge = (row) => {
        return <p>{row['Age']}</p>
    }

    const getSellerPOAndDate = (row) =>{
        return(
            <>
                <div className='font-semibold'>{row.sellerPODocNo}</div>
                <div>{getSellerPODate(row)}</div>
            </>
        )
    }

    const getVarianceProduct = (row) => <Description text={row.product} maxLength={200} />

    const getRejectionReason = (row) => <Description text={row.rejectionReason} maxLength={200} />

    const getDiscardedReason = (row) => <Description text={row.discardedReason} maxLength={200} width= "230px" />

    const getDiscartdedByAndAt = (row) => {
        return(
            <>
                <div>{row.DiscardedBy}</div>
                <div>{getDateString(row.discardedAt)}</div>
            </>
        )  
    }

    const getRejectedByAndAt = (row) => {
        return(
            <>
                <div>{row.RejectedBy}</div>
                <div>{getDateString(row.rejectedAt)}</div>
            </>
        )  
    }
    
    const getBuyerPOProductBody = (row) => {
        return `${row.productName} | ${row.productSpecification}`
    }

    const getBuyerPOSmartStockPrice = (row) => {
        let price = null
        if(row.smartStockPrice){
            price = round(parseFloat(row.smartStockPrice))
        }
        return price
    }

    const getBuyerPOOutStockPrice = (row) => {
        let price = null
        if(row.outStockPrice){
            price = round(parseFloat(row.outStockPrice))
        }
        return price
    }

    const getStockAgingBuyer = (row) => {
        return(
            <>
                <div className='font-semibold'>{row['BuyerPODoc']}</div>
                <div>{row['clientName']}</div>
            </>
        )
    }

    const getSellerPoDateOfStockConsumption = (row) =>{
        return getDateString(row.sellerPODate)
    }

    const getGRNDateOfStockConsumption = (row) =>{
        return getDateString(row.GRNDate)
    }

    const getInvoiceDateOfStockConsumption = (row) =>{
        return row.InvoiceDate ? getDateString(row.InvoiceDate) : "-"
    }

    const tableStockDocColumns = [
        {
            header: 'Material Id',
            field: 'materialId',
            style: { minWidth:"100px"}
        },
        {
            header: 'Product',
            field: '',
            body: getProductBody,
            style: { minWidth:"200px"}
        },
        {
            header: 'Specifications',
            field: '',
            body: getProductSpecification,
            style: { minWidth:"250px"}
        },
        {
            header: 'Doc No',
            field: '',
            body: getDocNoBody,
            style: { minWidth:"150px"}
        },
        {
            header: 'Doc Qty',
            field: 'docQty',
            style: { minWidth:"90px"}
        },
        {
            header: 'Pending Qty',
            field: 'pendingQty',
            style: { minWidth:"90px"}
        },
        {
            header: 'InProcess Qty',
            field: 'inProcessQty',
            style: { minWidth:"90px"}
        },
        {
            header: 'Invoiced Qty',
            field: 'invoicedQty',
            style: { minWidth:"120px"}
        },
        {
            header: 'Adjusted Qty',
            field: 'adjustedQty',
            style: { minWidth:"90px"}
        },
        {
            header: 'CNDN Qty',
            field: 'CNDNQty',
            style: { minWidth:"90px"}
        }
    ]

    const tableStockWarehouseColumns = [
        {
            header: 'Material Id',
            field: 'materialId',
            style: { minWidth:"100px"}
        },
        {
            header: 'Warehouse Name',
            field: 'warehouseName',
            // body: getWareHouseNameBody,
            style: { minWidth:"150px"}
        },
        {
            header: 'Product',
            field: 'product',
            // body: getProductBody,
            style: { minWidth:"200px"}
        },
        {
            header: 'Specifications',
            field: 'productSpecification',
            body: getProductSpecification,
            style: { minWidth:"250px"}
        },
        {
            header: 'In Stock',
            field: 'inStock',
            style: { minWidth:"80px"}
        },
        {
            header: 'Out Stock',
            field: 'outStock',
            style: { minWidth:"80px"}
        },
        {
            header: 'Dispatched Stock',
            field: 'dispatchedStock',
            style: { minWidth:"90px"}
        },
        {
            header: 'Smart Stock',
            field: 'smartStock',
            style: { minWidth:"80px"}

        },
        {
            header: 'Rejected Stock',
            field: 'rejectedStock',
            style: { minWidth:"90px"}
        },
        {
            header: 'Discarded Stock',
            field: 'discardedStock',
            style: { minWidth:"90px"}
        },
        {
            header: 'Outstock Value',
            field: 'outStockValue',
        },
        {
            header: 'Smart Stock Value',
            field: 'smartStockValue',
            style: { minWidth:"100px"}
        },
        // {
        //     header: 'Last Smart Price',
        //     field: 'lastSmartPrice',
        //     style: { minWidth:"120px"}
        // },
        // {
        //     header: 'Last Rejected Price',
        //     field: 'lastRejectedPrice',
        //     style: { minWidth:"120px"}
        // },
        // {
        //     header: 'Smart Stock Price',
        //     field: 'smartStockPrice',
        //     style: { minWidth:"120px"}
        // },
        // {
        //     header: 'Last Move Date',
        //     field: '',
        //     body: getLastMoveDateAndCreatedBy,
        //     style: { minWidth:"150px"}
        // }
    ]

    const tableStockMoveColumns = [

        // {
        //     header: 'StockMove Id',
        //     field: 'stockMoveId',
        // },
        {
            header: 'Material Id',
            field: 'materialId',
        },
        {
            header: 'Warehouse Name',
            field: '',
            body: getWareHouseNameBody,
            style: { minWidth:"150px"}
        },
        {
            header: 'Product',
            field: '',
            body: getProductDetailsBody,
            style: { minWidth:"250px"}
        },
        {
            header: 'Move Qty',
            field: 'moveQty',
            style: { minWidth:"80px"}
        },
        {
            header: 'Price',
            field: 'price',
            body: getPrice,
            style: { minWidth:"70px"}
        },
        {
            header: 'Move Date',
            field: '',
            body: getMoveDateAndCreatedBy,
            style: { minWidth:"100px"}
        },
        {
            header: 'Doc No/Move name',
            field: 'docNo',
            body: getDocNoandMoveTypeBody,
            style: { minWidth:"110px"}
        },
        {
            header: 'Buyer Details',
            field: 'buyerPOId',
            body: getBuyerNameAndBuyerPOIdBody,
            style: { minWidth:"150px"}
        },
        {
            header: 'Buyer DocNo',
            field: '',
            body: getBuyerDocNoBody,
            style: { minWidth:"100px"}
        },
        {
            header: 'Seller Details',
            field: '',
            body: getSellerNameAndSellerPOIdBody,
            style: { minWidth:"150px"}
        },
        {
            header: 'Seller DocNo',
            field: '',
            body: getSellerDocNoBody,
            style: { minWidth:"100px"}
        },
        {
            header: 'Remarks',
            field: 'remarks',
            body: getRemarks,
            style: { minWidth:"200px"}
        }
    ]

    const tableMovementReportColumn = [
        {
            header: 'Material Id',
            field: 'materialId',
        },
        {
            header: 'Warehouse Name',
            field: 'warehouseName',
            style: { minWidth:"150px"}
        },
        {
            header: 'product',
            field: 'product',
            style: { minWidth:"150px"}
        },
        {
            header: 'Opening Qty',
            field: 'openingQty',
        },
        {
            header: 'Received Qty',
            field: 'receivedQty',
        },
        {
            header: 'Adjusted Qty',
            field: 'adjustedQty',
        },
        {
            header: 'Recieved By CNQty',
            field: 'recievedByCNQty'
        },
        {
            header: 'Dispatched Qty',
            field: 'dispatchedQty',
        },
        {
            header: 'Closing Qty',
            field: 'closingQty',
        },
        {
            header: 'Opening Amount',
            field: 'openingAmount',
            body: getOpeningAmount
        },
        {
            header: 'Received Amount',
            field: 'receivedAmount',
            body: getReceivedAmount
        },
        {
            header: 'Dispatched Amount',
            field: 'dispatchedAmount',
            body: getDispatchedAmount
        },
        {
            header: 'Closing Amount',
            field: 'closingAmount',
            body: getClosingAmount
        }
    ]

    const tableVarianceReportColumns = [
        {
            header: 'Material Id',
            field: 'materialId',
        },
        {
            header: 'Product',
            field: 'product',
            body: getVarianceProduct,
        },
        {
            header: 'Doc No',
            field: 'docNo',
            body: getDocNoBody
        },
        {
            header: 'KAM',
            field: 'KAMName',
            style: { minWidth:"100px"}
        },
        {
            header: 'Branch',
            field: 'city',
            style: { minWidth:"90px"}
        },
        {
            header: 'purchased Qty',
            field: 'purchasedQty',
        },
        {
            header: 'Price',
            field: 'price',
        },
        {
            header: 'Value',
            field: 'value',
        },
        {
            header: 'Dispatched Qty',
            field: 'dispatchedQty',
        },
        {
            header: '+ve Adjusted Qty',
            field: '+ve AdjustedQty',
            body: getPosAdjustedQty
        },
        {
            header: '-ve Adjusted Qty',
            field: '-ve AdjustedQty',
            body: getNegAdjustedQty
        },
        {
            header: 'Variance',
            field: 'variance',
            body: getVarianceValue
        },
    ]

    const tablebuyerPOStockReportColumns = [
        {
            header: 'Buyer Doc',
            field: 'docNo'
        },
        {
            header: 'Client PO Num',
            field: 'clientPONum'
        },
        {
            header: 'Client Name',
            field: 'clientName',
            style: { minWidth:"150px"}
        },
        {
            header: 'Material Id',
            field: 'materialId',
        },
        {
            header: 'Product',
            field: 'product',
            body: getBuyerPOProductBody,
            style: { minWidth:"150px"}
        },
        {
            header: 'Warehouse Name',
            field: 'warehouseName',
            style: { minWidth:"100px"}
        },
        {
            header: 'Company ERP Code',
            field: 'companyERPCode'
        },
        {
            header: 'Seller Doc',
            field: 'Seller Doc'
        },
        {
            header: 'Seller PO Qty',
            field: 'Seller PO Qty'
        },
        {
            header: 'KAM',
            field: 'KAMName',
            style: { minWidth:"120px"}
        },
        {
            header: 'In Stock',
            field: 'inStock',
        },
        {
            header: 'Smart Stock',
            field: 'smartStock',
        },
        {
            header: 'Smart Stock Price',
            field: 'smartStockPrice',
            body: getBuyerPOSmartStockPrice
        },
        {
            header: 'Out Stock',
            field: 'outStock',
        },
        {
            header: 'Out Stock Price',
            field: 'outStockPrice',
            body: getBuyerPOOutStockPrice
        },
        {
            header: 'Rejected Stock',
            field: 'rejectedStock',
        },
        {
            header: 'Rejected Price',
            field: 'rejectedPrice',
        },
        {
            header: 'Dispatched Stock',
            field: 'dispatchedStock',
        },
        {
            header: 'Discarded Stock',
            field: 'discardedStock',
        }
    ]

    const tableStockScrapReportColumns = [
        {
            header: 'Material Id',
            field: 'materialId',
        },
        {
            header: 'Warehouse Name',
            field: 'warehouseName',
            style: { minWidth:"100px"}
        },
        {
            header: 'Product',
            field: 'product',
            style: { minWidth:"130px"}
        },
        {
            header: 'Product Specification',
            field: 'productSpecification',
            body: getProductSpecification,
            style: { minWidth:"160px"}
        },
        {
            header: 'Credit Note No',
            field: 'CreditNote No'
        },
        {
            header: 'Discarded Qty',
            field: 'discardedQty'
        },
        {
            header: 'Discarded Amount',
            field: 'discardedAmount'
        },
        {
            header: 'Discarded By/At',
            field: 'DiscardedBy',
            body: getDiscartdedByAndAt,
            style: { minWidth:"100px"}
        },
        // {
        //     header: 'Discarded At',
        //     field: 'discardedAt',
        //     style: { minWidth:"90px"}
        // },
        {
            header: 'Discarded Reason',
            field: 'discardedReason',
            body: getDiscardedReason,
            style: { minWidth:"150px"}
        },
        {
            header: 'Rejected By',
            field: 'RejectedBy',
            body: getRejectedByAndAt,
            style: { minWidth:"100px"}
        },
        // {
        //     header: 'Rejected At',
        //     field: 'rejectedAt',
        //     style: { minWidth:"90px"}
        // },
        {
            header: 'Rejection Reason',
            field: 'rejectionReason',
            body: getRejectionReason,
            style: { minWidth:"200px"}
        },
    ]

    const tableStockAgingReportColumns = [
        {
            header: 'Material Id',
            field: 'materialId',
        },
        {
            header: 'Warehouse Name',
            field: 'warehouseName',
            style: { minWidth:"150px"}
        },
        {
            header: 'Product',
            field: 'product',
            style: { minWidth:"150px"}
        },
        {
            header: 'Product Specification',
            field: 'productSpecification',
            body: getProductSpecification
        },
        {
            header: 'Category',
            field: 'Product Industry',
        },
        {
            header: 'Buyer PO Doc',
            body: getStockAgingBuyer,
            style: { minWidth:"160px"}
        },
        {
            header: 'Seller PO',
            field: 'sellerPODocNo',
            body: getSellerPOAndDate,
            style: { minWidth:"160px"}
        },
        {
            header: 'Seller Invoice No',
            field: 'sellerInvoiceNo'
        },
        {
            header: 'KAM Name',
            field: 'KAMName'
        },
        {
            header: 'Type',
            field: 'Type',
            style: { minWidth:"90px"}
        },
        {
            header: 'Qty',
            field: 'Qty'
        },
        {
            header: 'UOM',
            field: 'UOM'
        },
        {
            header: 'Price',
            field: 'price',
        },
        {
            header: 'Stock Value',
            field: 'StockValue',
            body: getStockValue
        },
        {
            header: 'GRNDate',
            field: 'GRNDate',
            body: getGRNDates,
            style: { minWidth:"100px"}
        },
        {
            header: 'Age',
            field: 'Age',
            body: getAge
        },
        {
            header: 'Stock Aging Bucket',
            field: 'Stock Ageing Bucket'
        }
    ]

    const tableRejectedStockReportColumns = [
        {
            header: 'Material Id',
            field: 'materialId',
        },
        {
            header: 'Warehouse Name',
            field: 'warehouseName',
            style: { minWidth:"100px"}
        },
        {
            header: 'Product',
            field: 'product',
            style: { minWidth:"130px"}
        },
        {
            header: 'Product Specification',
            field: 'productSpecification',
            body: getProductSpecification,
            style: { minWidth:"160px"}
        },
        {
            header: "Buyer PO",
            field: "buyerDoc"
        },
        {
            header: "Seller PO",
            field: "sellerDoc"
        },
        {
            header: 'Buyer Invoice No',
            field: 'buyerInvoiceNo'
        },
        {
            header: 'Credit Note No',
            field: 'CreditNote No'
        },
        {
            header: 'Client name',
            field: 'clientName',
            style: { minWidth:"180px"},
        },
        {
            header: 'Client Hold Qty',
            field: 'clientHoldQty'
        },
        {
            header: 'Client Hold Value',
            field: 'clientHoldValue'
        },
        {
            header: 'Rejected qty',
            field: 'rejectedQty',
        },
        {
            header: 'Price',
            field: 'price'
        },
        {
            header: 'Rejected Value',
            field: 'rejectedValue',
        },
        // {
        //     header: 'Rejected at',
        //     field: 'rejectedAt'
        // },
        {
            header: 'Rejected by',
            field: 'RejectedBy',
            body: getRejectedByAndAt,
            style: { minWidth:"100px"},
        },
        {
            header: 'Rejection reason',
            field: 'rejectionReason',
            style: { minWidth:"270px"},
            body: getRejectedReasonText
        }
    ]

    const tableStockConsumptionReportColumns = [
        {
            header: 'Material Id',
            field: 'materialId',
        },
        {
            header: 'Warehouse Name',
            field: 'warehouseName',
            style: { minWidth:"150px"}
        },
        {
            header: 'Product',
            field: 'product',
            style: { minWidth:"180px"}
        },
        {
            header: 'Product Specification',
            field: 'productSpecification',
            body: getProductSpecification,
            style: { minWidth:"160px"}
        },
        {
            header: 'PM Branch',
            field: 'PMBranch'
        },
        {
            header: 'Stock Seller PO',
            field: 'stockSellerPO',
            style: { minWidth:"120px"}
        },
        {
            header: 'Seller PO Date',
            field: 'sellerPODate',
            body: getSellerPoDateOfStockConsumption,
            style: { minWidth:"100px"}
        },
        {
            header: 'KAM Name',
            field: 'KAMName',
            style: { minWidth:"130px"}
        },
        {
            header: 'GRN Date',
            field: 'GRNDate',
            body: getGRNDateOfStockConsumption,
            style: { minWidth:"100px"}
        },
        {
            header: 'Seller Name',
            field: 'SellerName',
            style: { minWidth:"180px"}
        },
        {
            header: 'useFromStock Seller PO',
            field: 'useFromStockSellerPO'
        },
        {
            header: 'Consumed Qty',
            field: 'consumedQty'
        },
        {
            header: 'Buyer Doc No',
            field: 'buyerDocNo',
            style: { minWidth:"120px"}
        },
        {
            header: 'Client Name',
            field: 'ClientName',
            style: { minWidth:"180px"}
        },
        {
            header: 'Invoice Date',
            field: 'InvoiceDate',
            body: getInvoiceDateOfStockConsumption,
            style: { minWidth:"100px"}
        }
    ]

    let [tableColumns, setTableColumns] = useState(tableStockDocColumns)

    let stockReportHeading = 'STOCK REPORT'
    if (searchParams?.dataType && searchOptions) {
        const dataTypeOptions = searchOptions?.find(eachSearchOpt => eachSearchOpt?.name === "dataType")
        const realatedDataType = dataTypeOptions?.options?.find(eachDataType => eachDataType?.value === searchParams?.dataType)

        stockReportHeading = realatedDataType?.label.toUpperCase()
    }

    const actionButtons = [
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
    ]
    

    return(
        <div className='flex flex-column'>
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">{stockReportHeading}</h4> 
                <div className="flex gap-2 justify-content-end mb-2">
                    {/* <Button icon="pi pi-filter" className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className='flex flex-row'>
                <div className="stock-report-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <Table 
                                lazy 
                                page={paginationParams.pageNo} 
                                onPageChange={(e)=> handlePageChange(e)} 
                                totalRecords={paginationParams.totalRecords} 
                                tableColumns={tableColumns} 
                                data={stockReportData} 
                                rows={paginationParams.recordsPerPage} 
                                scrollable={"true"} 
                                scrollHeight="550px"
                                paginator
                                excessPagesFound={paginationParams.excessPagesFound}
                                loading={isPageLoading}  
                            />
                        </div>
                    </div>
                </div>
                {
                    isSearchVisible && !isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                            <Search
                                handleTableColumn={handleTableColumn}
                                companyWarehouses={companyWarehouses}
                                statusList={statusList}
                                materialBrands={materialBrands}
                                stockMoveTypes={stockMoveTypes}
                            />
                        </div>
                }
                {
                    isSearchVisible && isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                            <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                                <Search
                                    handleTableColumn={handleTableColumn}
                                    companyWarehouses={companyWarehouses}
                                    statusList={statusList}
                                    materialBrands={materialBrands}
                                    stockMoveTypes={stockMoveTypes}
                                />
                            </Sidebar>
                        </div>
                }
            </div>

        </div>
    )
}

export default StockReport